export default __webpack_public_path__ + "static/media/wTop_1_p3.d76923c4.jpeg";